import { api } from '@api'
import { FetchParams, PaginatedResponse } from './types'
import { usePaginate } from './usePaginate'

export type Category = {
  id: string
  avatarUrl: string | null
  name: string
  contactAccountIds?: string[]
}

const fetchCategories = async ({ pageParam = '0', q }: FetchParams): Promise<PaginatedResponse<Category>> => {
  // URLSearchParams encodes the typed text: "R&D" or "#sport" pasted as is
  // would cut the address at the "&" or the "#".
  const params = new URLSearchParams()
  params.append('page', pageParam)
  if (q) {
    params.append('q', q)
  }
  const url = `/categories?${params.toString()}`
  const { data } = await api.get<PaginatedResponse<Category>>(url)
  return data
}

export const usePaginateCategories = (q?: string) => {
  return usePaginate<Category>('categories', fetchCategories, {q})
}
